import { createContext } from "react";

export type NotificationType = "error" | "success" | "warn" | "info";

export const NotificationContext = createContext({
  notification: { message: "", type: "", timeout: 8000, centered: false },
  setNotification: (
    _message: string,
    _type: NotificationType,
    _timeout?: number,
    _centered?: boolean
  ) => {},
  removeNotification: () => {},
});
